import React, {useEffect, useState} from 'react';
import ResizeObserver from 'resize-observer-polyfill'
import PropTypes from 'prop-types';
import styles from './BigScreen.less'

function ScreenAdapter(props) {
    const [screenWidth, setScreenWidth] = useState(document.documentElement.clientWidth)
    const [screenHeight, setScreenHeight] = useState(document.documentElement.clientHeight)
    const [screenScale, setScreenScale] = useState(1)

    useEffect(() => {
        const screenAdapter = document.getElementById('ScreenAdapter')
        // screenAdapter.style.height = screenAdapter.parentElement.clientHeight + 'px'
        const scale = screenAdapter?.parentElement?.clientWidth / 1862
        setScreenScale(scale)
        // window.onresize = debounce(getScale, 1000)
        ro.observe(screenAdapter?.parentElement)
    }, [])

    // useEffect(() => {
    //     const screenAdapter = document.getElementById('ScreenAdapter')
    //     screenAdapter.style.height = screenAdapter.parentElement.clientHeight + 'px'
    // }, [])

    const ro = new ResizeObserver((entries, observer) => {
        for (const entry of entries) {
            const {left, top, width, height} = entry.contentRect;
    
            console.log('Element:', entry.target);
            console.log(`Element's size: ${ width }px x ${ height }px`);
            console.log(`Element's paddings: ${ top }px ; ${ left }px`);
            getScale()
        }
    });

    const debounce = (fn, t) => {
        const delay = t || 500
        let timer
        return () => {
            // const args = arguments
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                timer = null
                fn()
            }, delay)
        }
    }
    // 获取放大缩小比例
    const getScale = () => {
        const w = window.innerWidth / screenWidth
        const h = window.innerHeight / screenHeight
        // const scale = w < h ? w : h
        const screenAdapter = document.getElementById('ScreenAdapter')
        // const bigScreen = document.getElementById('bigScreen')
        const scale = screenAdapter?.parentElement.clientWidth / screenAdapter?.clientWidth
        setScreenScale(scale)
    } 
    // 设置比例
    // const screenTransform = `scale(${screenScale}) translate(-50%, -50%)`
    const screenTransform = `scale(${screenScale})`
    return (
        // <div id='ScreenAdapter' className={styles.screenAdapter} style={{width: screenWidth, height: screenHeight, transform: screenTransform}}>
        <div id='ScreenAdapter' className={`${styles.screenAdapter} ${props.loadding ? styles.bigScreenSpin : null}`} style={{transform: screenTransform}}>
            {props.children}
        </div>
    )
}
ScreenAdapter.propTypes = {
    baseinfo: PropTypes.object,
    name: PropTypes.string
}
export default ScreenAdapter;